export default "__VITE_ASSET__BT50RwGu__"